import type { FixedPhonePlan } from "../../slice/types";

export type StandalonePlanDuration = "monthly" | "yearly";

export function normalizePlanDuration(
  raw?: string | null,
): StandalonePlanDuration | "" {
  const d = String(raw ?? "")
    .trim()
    .toLowerCase();
  if (!d) return "";
  if (d === "monthly" || d === "month") return "monthly";
  if (
    d === "yearly" ||
    d === "year" ||
    d === "annual" ||
    d === "annually" ||
    d === "12"
  ) {
    return "yearly";
  }
  return "";
}

/** Normalize API plan rows to monthly/yearly for UI + matching. */
export function normalizePlanTypeFromRecord(
  plan: Pick<FixedPhonePlan, "planType" | "billingCycle" | "planName"> | null,
): StandalonePlanDuration | "" {
  if (!plan) return "";

  const fromType = normalizePlanDuration(plan.planType);
  if (fromType) return fromType;

  const billing = String(plan.billingCycle ?? "").toLowerCase();
  if (billing === "month" || billing === "monthly") return "monthly";
  if (
    billing === "year" ||
    billing === "yearly" ||
    billing === "annual" ||
    billing === "annually"
  ) {
    return "yearly";
  }

  const name = String(plan.planName ?? "").toLowerCase();
  if (name.includes("unlimited yearly") || name.includes("annual")) {
    return "yearly";
  }
  if (name.includes("unlimited monthly")) return "monthly";

  return "";
}

export function planRecordMatchesDuration(
  plan: Pick<FixedPhonePlan, "planType" | "billingCycle" | "planName">,
  duration: StandalonePlanDuration,
): boolean {
  return normalizePlanTypeFromRecord(plan) === duration;
}

export function resolvePlanIdByDuration(
  plans: FixedPhonePlan[] | undefined,
  durationRaw?: string | null,
): string {
  const duration = normalizePlanDuration(durationRaw);
  if (!duration || !plans?.length) return "";

  const match = plans.find((plan) => planRecordMatchesDuration(plan, duration));
  if (!match) return "";

  return String(match._id ?? match.id ?? "");
}
